import React, { Fragment } from "react"
import classnames from "classnames"

import DefaultContainer from "shared/components/DefaultContainer"
import Table from "./Table"
import DefaultTitle from "shared/components/DefaultTitle"

import styles from "./styles.css"

const IncidentManagerSkeleton = () => {
  const inputClasses = classnames(styles.input, styles.skeleton)

  return (
    <Fragment>
      <DefaultTitle>Protocolos</DefaultTitle>
      <DefaultContainer>
        <div className="u-flex inputs">
          <div className={inputClasses}></div>
          <div className={inputClasses}></div>
        </div>
        <Table />
      </DefaultContainer>
    </Fragment>
  )
}

export default IncidentManagerSkeleton



// WEBPACK FOOTER //
// ./src/components/Skeleton/IncidentManagerSkeleton/index.js